import React from 'react';
import { Skeleton } from './skeleton';
import { Card, CardContent, CardHeader } from './card';

// Basic loading spinner
export const LoadingSpinner = ({ size = 'default' }: { size?: 'sm' | 'default' | 'lg' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    default: 'w-8 h-8', 
    lg: 'w-12 h-12'
  };

  return (
    <div className="flex items-center justify-center">
      <div className={`${sizeClasses[size]} animate-spin rounded-full border-2 border-primary border-t-transparent`} />
    </div>
  );
};

// Page loading component
export const PageLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="text-center space-y-4">
      <LoadingSpinner size="lg" />
      <p className="text-muted-foreground">Načítava sa...</p>
    </div>
  </div>
);

// Module card loading skeleton
export const ModuleCardSkeleton = () => (
  <Card className="glass-card">
    <CardHeader className="pb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-4">
          <Skeleton className="h-12 w-12 rounded-lg" />
          <div className="space-y-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
      </div>
    </CardHeader>
    <CardContent>
      <Skeleton className="h-4 w-full mb-4" />
      <div className="grid md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <Skeleton className="h-4 w-24 mb-3" />
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} className="h-3 w-full" />
          ))}
        </div>
        <div className="space-y-3">
          <Skeleton className="h-4 w-20 mb-3" />
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex items-center space-x-2">
              <Skeleton className="h-4 w-4 rounded" />
              <Skeleton className="h-3 w-28" />
            </div>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
);

// Features page loading
export const FeaturesLoading = () => (
  <div className="section-padding">
    <div className="container-custom">
      <div className="space-y-16">
        {[...Array(6)].map((_, index) => (
          <ModuleCardSkeleton key={index} />
        ))}
      </div>
    </div>
  </div>
);